<template>
  <el-dialog
    width="40%"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="onCancel"
  >
    <el-form
      v-show="visible"
      :validate-on-rule-change="false"
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="onSubmit"
      label-width="120px"
    >
      <el-form-item class="styW" label="账户类型" prop="accountType">
        <el-select
          v-model="dataForm.accountType"
          placeholder="请选择账户类型"
          style="width: 100%"
          @change="onAccountTypeChange"
          :disabled="isEdit"
        >
          <el-option label="小贷" value="LOAN" />
          <el-option label="资方" value="FUND" />
        </el-select>
      </el-form-item>
      <el-form-item class="styW" label="系统用户" prop="userId">
        <el-select
          v-model="dataForm.userId"
          filterable
          clearable
          placeholder="请选择系统用户"
          style="width: 100%"
        >
          <el-option
            v-for="item in fundList"
            :key="item.userId"
            :value="item.userId"
            :label="item.deptName"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="dataForm.accountType === 'FUND'"
        class="styW"
        label="关联小贷账户"
        prop="parentId"
      >
        <el-select
          v-model="dataForm.parentId"
          filterable
          clearable
          placeholder="请选择小贷账户"
          style="width: 100%"
        >
          <el-option
            v-for="loan in loanList"
            :key="loan.id"
            :value="loan.id"
            :label="`${loan.companyName} (${loan.userId})`"
          />
        </el-select>
      </el-form-item>
      <el-form-item class="styW" label="商户标识" prop="appId">
        <el-input v-model="dataForm.appId" placeholder="请输入" />
      </el-form-item>
      <el-form-item class="styW" label="商户代码编号" prop="merNo">
        <el-input v-model="dataForm.merNo" placeholder="请输入" />
      </el-form-item>
      <el-form-item class="styW" label="公司名称" prop="companyName">
        <el-input v-model="dataForm.companyName" placeholder="请输入" />
      </el-form-item>
      <el-form-item class="styW" label="私钥证书名称" prop="keyStorePath">
        <el-input v-model="dataForm.keyStorePath" placeholder="请输入" />
      </el-form-item>
      <el-form-item class="styW" label="私钥证书密码" prop="keyStorePassword">
        <el-input v-model="dataForm.keyStorePassword" placeholder="请输入" show-password />
      </el-form-item>
      <el-form-item class="styW" label="公钥证书名称" prop="publicKeyStorePath">
        <el-input v-model="dataForm.publicKeyStorePath" placeholder="请输入" />
      </el-form-item>
      <el-form-item class="styW" label="虚拟账号" prop="virtualAccount">
        <el-input v-model="dataForm.virtualAccount" placeholder="请输入" />
      </el-form-item>
      <el-form-item class="styW" label="支付方式" prop="payType">
        <el-select
          v-model="dataForm.payType"
          placeholder="请选择支付方式"
          style="width: 100%"
          :disabled="isEdit"
        >
          <el-option
            v-for="opt in payTypeList"
            :key="opt.value"
            :label="opt.label"
            :value="opt.value"
            :disabled="opt.value !== '1'"
          />
        </el-select>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="onCancel">{{ $t('cancel') }}</el-button>
      <el-button type="primary" :loading="isConfirm" @click="onSubmit">
        {{ $t('confirm') }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  name: 'AccountDialog',
  data() {
    return {
      visible: false,
      isEdit: false,
      isConfirm: false,
      fundList: [],
      loanList: [],
      payTypeList: [],
      type: 'add',
      dataForm: {
        id: '',
        accountType: '',
        payType: '',
        parentId: 0,
        userId: '',
        appId: '',
        merNo: '',
        companyName: '',
        keyStorePath: '',
        keyStorePassword: '',
        publicKeyStorePath: '',
        virtualAccount: ''
      }
    }
  },
  computed: {
    dataRule() {
      return {
        accountType: [{ required: true, message: '请选择账户类型', trigger: 'change' }],
        userId: [{ required: true, message: '请选择系统用户', trigger: 'change' }],
        parentId: [
          {
            required: this.dataForm.accountType === 'FUND',
            message: '请选择关联小贷账户',
            trigger: 'change'
          }
        ],
        appId: [{ required: true, message: '请输入商户标识', trigger: 'blur' }],
        merNo: [{ required: true, message: '请输入商户代码编号', trigger: 'blur' }],
        companyName: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        payType: [{ required: true, message: '请选择支付方式', trigger: 'change' }]
      }
    }
  },
  created() {
    // 加载支付方式字典
    this.$http.get('/sys/dict/data/list?dataType=ttf_pay_type').then(({ data }) => {
      this.payTypeList = data.data.map(item => ({
        value: String(item.dictValue),
        label: item.dictLabel
      }))
    })
    // 加载资方系统用户列表
    this.$http.get('/sys/user/queryUserIdList').then(({ data }) => {
      this.fundList = data.data
    })
    // 加载小贷列表
    this.loadLoanList()
  },
  methods: {
    init() {
      this.visible = true
      this.isEdit = this.type === 'update'
      this.$nextTick(() => {
        // 重置校验状态
        this.$refs.dataForm.resetFields()
        this.$refs.dataForm.clearValidate()

        if (this.isEdit && this.dataForm.id) {
          // 修改回显
          this.getInfo(this.dataForm.id)
        } else {
          // 新增场景清空
          Object.assign(this.dataForm, {
            id: '',
            accountType: '',
            payType: '',
            parentId: 0,
            userId: '',
            appId: '',
            merNo: '',
            companyName: '',
            keyStorePath: '',
            keyStorePassword: '',
            publicKeyStorePath: '',
            virtualAccount: ''
          })
        }
      })
    },

    loadLoanList() {
      this.$http
        .get('/ttf/account/page', { params: { parentId: '0' } })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.loanList = res.data.list
          }
        })
    },

    onAccountTypeChange(val) {
      //切换类型, 小贷下 parentId 归零
      this.dataForm.parentId = val === 'LOAN' ? 0 : ''
      this.$refs.dataForm.clearValidate()
    },

    getInfo(id) {
      this.$http.get(`/ttf/account/info/${id}`).then(({ data: res }) => {
        if (res.code === 0) {
          const { parentId, userId, payType, accountType, ...rest } = res.data
          this.dataForm = Object.assign({}, this.dataForm, rest, {
            id,
            parentId,
            userId,
            // 强制转为字符串，与 payTypeList 的 value 对应
            payType: String(payType),
            accountType // 后端返回已含此字段
          })
          this.$refs.dataForm.clearValidate()
        } else {
          this.$message.error(res.msg || '获取详情失败')
        }
      })
    },

    onCancel() {
      this.visible = false
      this.$refs.dataForm.resetFields()
      this.$refs.dataForm.clearValidate()
    },

    onSubmit: debounce(function() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        this.isConfirm = true
        const api = this.type === 'update' ? 'put' : 'post'
        this.$http[api]('/ttf/account', this.dataForm)
          .then(({ data }) => {
            this.isConfirm = false
            if (data.code !== 0) {
              return this.$message.error(data.msg)
            }
            this.$message.success('操作成功')
            this.visible = false
            this.$emit('refreshDataList')
          })
          .catch(() => {
            this.isConfirm = false
          })
      })
    }, 500)
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog {
  min-width: 700px;
}
.styW {
  width: 480px;
}
</style>